export default "__VITE_ASSET__a_Csh$SH__"